module.exports = __webpack_public_path__ + "static/img/poster.2320480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tw-img/poster.png
// module id = VJ+u
// module chunks = 1